/* Coria: stable launcher and explicit, locale-aware quick ordering. */
(function () {
  'use strict';
  if (window.CoriaAssistantBridge) return;
  var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var dialog, returnFocus, busy = false;
  var quietUntil = 0, lastPrompt = 0;
  try { quietUntil = Number(sessionStorage.getItem('coria_quiet_until')) || 0; } catch (_) {}
  function quiet(ms, silent) {
    quietUntil = Date.now() + (ms || 300000); cpCache.t = 0;
    try { sessionStorage.setItem('coria_quiet_until', String(quietUntil)); } catch (_) {}
    if (!silent) document.dispatchEvent(new CustomEvent('coria:quiet'));
  }
  /* 20.10.2026 viteza: robotul intreaba la fiecare cadru; verificarea completa (cauta ferestre modale, citeste stilul) costa o recalculare
     de stil pe ~5.000 de elemente -> rezultatul se tine minte 700 ms si se goleste la claim/quiet. */
  var cpCache = { t: 0, v: true };
  function canPrompt() {
    var now = Date.now();
    if (now - cpCache.t < 700) return cpCache.v;
    cpCache.t = now; cpCache.v = canPromptRaw();
    return cpCache.v;
  }
  function canPromptRaw() {
    if (document.hidden || Date.now() < quietUntil || Date.now() - lastPrompt < 45000) return false;
    if (document.documentElement.classList.contains('cf-bfp-on')) return false; /* 20.10.2026: pauza Black Friday -> fara bule */
    try { if (sessionStorage.getItem('coria_buddy_off') === '1') return false; } catch (_) {}
    var focused = document.activeElement;
    if (focused && focused.matches('input,textarea,select,[contenteditable="true"]')) return false;
    /* 20.10.2026: sertarele/popup-urile inchise pastreaza aria-modal="true" (cart-drawer, popup-ul BF .cf-bfp) si blocau toate bulele robotului;
       acum conteaza doar fereastra modala chiar vizibila. */
    var modals = document.querySelectorAll('#coria-box[aria-hidden="false"],dialog[open],.side-drawer.show,.cbs-cart.is-on,.cbs-holo.is-on,[aria-modal="true"]:not([aria-hidden="true"])');
    for (var i = 0; i < modals.length; i++) {
      var r = modals[i].getBoundingClientRect(), cs = getComputedStyle(modals[i]);
      if (r.width > 1 && r.height > 1 && cs.visibility !== 'hidden' && cs.display !== 'none' && +cs.opacity !== 0) return false;
    }
    return true;
  }
  function claimPrompt() { cpCache.t = 0; if (!canPrompt()) return false; lastPrompt = Date.now(); cpCache.t = 0; return true; }
  function restore() {
    var fab = document.getElementById('coria-fab'), box = document.getElementById('coria-box');
    if (!fab || (box && box.getAttribute('aria-hidden') === 'false')) return;
    if (!document.querySelector('#coria-buddy.is-ready')) {
      document.documentElement.classList.remove('cb-on');
      fab.classList.add('coria-launcher-restored');
      fab.removeAttribute('aria-hidden'); fab.removeAttribute('tabindex');
      fab.style.removeProperty('display');
    }
  }
  function open() {
    if (window.CoriaWidget && typeof window.CoriaWidget.open === 'function') window.CoriaWidget.open();
    else { var fab = document.getElementById('coria-fab'); if (fab) fab.click(); }
  }
  function ask(question) {
    open();
    var input=document.getElementById('coria-input');
    if(!input)return;
    if(!input.value.trim()){input.value=String(question||'').slice(0,input.maxLength>0?input.maxLength:500);input.dispatchEvent(new Event('input',{bubbles:true}));}
    input.focus();
  }
  function node(tag, text, parent) { var el = document.createElement(tag); if (text) el.textContent = text; if(parent)parent.appendChild(el); return el; }
  function link(text, path, parent) { var a=node('a',text,parent); a.href=rootPath+path; return a; }
  function readProduct() { try { return JSON.parse(document.getElementById('coria-quick-product').textContent); } catch (_) { return null; } }
  function order(product) {
    if (dialog && dialog.open) return;
    returnFocus=document.activeElement;
    if(dialog)dialog.remove();
    dialog=node('dialog',null,document.body); dialog.id='coria-quick-order'; dialog.setAttribute('aria-labelledby','coria-order-title');
    var close=node('button','×',dialog); close.type='button';close.className='cqo-close';close.setAttribute('aria-label','Închide');
    var title=node('h2','Comandă mai simplu',dialog);title.id='coria-order-title';
    var body=node('div',null,dialog);body.className='cqo-body';
    close.addEventListener('click',function(){if(!busy)dialog.close();});
    dialog.addEventListener('cancel',function(e){if(busy)e.preventDefault();});
    dialog.addEventListener('close',function(){if(returnFocus && returnFocus.isConnected)returnFocus.focus();});
    var supplied=product && Array.isArray(product.variants);
    var p=supplied?product:readProduct();
    var mainForm=supplied?null:document.querySelector('form.main-product-form');
    var complex=(p&&p.requires_selling_plan)||(mainForm && mainForm.querySelector('[name^="properties["], [name="selling_plan"]'));
    if (p && p.variants && p.variants.length && !complex) {
      node('h3',p.title,body);
      var form=node('form',null,body);
      var vl=node('label','Variantă',form);vl.htmlFor='cqo-variant';
      var select=node('select',null,form);select.id='cqo-variant';
      var currency=(window.Shopify && Shopify.currency && Shopify.currency.active)||'RON';
      var money=function(cents){try{return new Intl.NumberFormat(document.documentElement.lang||'ro-RO',{style:'currency',currency:currency}).format(cents/100);}catch(_){return (cents/100).toFixed(2)+' '+currency;}};
      p.variants.forEach(function(v){var o=node('option',(v.title==='Default Title'?'Standard':v.title)+' — '+money(v.price)+(v.available?'':' · Indisponibil'),select);o.value=String(v.id);o.disabled=!v.available;});
      var nativeId=mainForm && mainForm.querySelector('[name="id"]');
      var selected=p.variants.find(function(v){return nativeId && String(v.id)===String(nativeId.value) && v.available;})||p.variants.find(function(v){return v.available;});
      if(selected)select.value=String(selected.id);
      var ql=node('label','Cantitate',form);ql.htmlFor='cqo-quantity';
      var qty=node('input',null,form);qty.id='cqo-quantity';qty.type='number';qty.required=true;qty.inputMode='numeric';
      var status=node('p','',form);status.className='cqo-status';status.setAttribute('role','status');status.setAttribute('aria-live','polite');
      var add=node('button','Adaugă în coș',form);add.type='submit';add.className='cqo-primary';
      function variant(){return p.variants.find(function(v){return String(v.id)===select.value;});}
      function update(){var v=variant(),r=(v&&v.quantity_rule)||{min:1,increment:1};qty.min=r.min||1;qty.step=r.increment||1;if(r.max)qty.max=r.max;else qty.removeAttribute('max');qty.value=qty.min;add.disabled=!v||!v.available;status.textContent=v&&v.available?'Selectează varianta și cantitatea.':'Produsul nu este disponibil.';}
      select.addEventListener('change',update);update();
      form.addEventListener('submit',async function(e){
        e.preventDefault();if(busy||!form.reportValidity())return;
        var v=variant(),amount=Number(qty.value);if(!v||!v.available||!Number.isSafeInteger(amount)||amount<1)return;
        busy=true;add.disabled=true;select.disabled=true;qty.disabled=true;close.disabled=true;status.textContent='Se adaugă în coș…';
        var payload={id:v.id,quantity:amount},cart=document.querySelector('cart-drawer');
        try { if(cart&&cart.getSectionsToRender){payload.sections=cart.getSectionsToRender().map(function(s){return s.section;});payload.sections_url=location.pathname;} } catch(_){cart=null;}
        var success=false,controller=new AbortController(),timeout=setTimeout(function(){controller.abort();},20000);
        try {
          var response=await fetch(rootPath+'cart/add.js',{signal:controller.signal,method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
          var result=await response.json();
          if(!response.ok||result.status>=400)throw new Error(result.description||result.message||'Produsul nu a putut fi adăugat.');
          success=true;
          if(window.CoriaCommerce)CoriaCommerce.track('add_success',{mode:'quick',count:amount});
          var actualTitle=result.product_title||p.title;
          var actualVariant=result.variant_title||v.title;
          status.textContent='Adăugat: '+amount+' × '+actualTitle+(actualVariant&&actualVariant!=='Default Title'?' — '+actualVariant:'')+'.';
          var next=node('div',null,form);next.className='cqo-links';
          link('Vezi coșul','cart',next);link('Finalizează comanda','checkout',next);
          document.dispatchEvent(new CustomEvent('cart:item-added',{detail:{item:result,source:'coria-buddy'}}));
          if(cart&&cart.renderContents&&result.sections){try{cart.renderContents(result);}catch(_){/* Confirmed add must never be retried after a rendering failure. */}}
          if(window.CoriaBuddy)window.CoriaBuddy.feel('star',3);
        } catch(error){if(window.CoriaCommerce)CoriaCommerce.track('add_error',{mode:'quick'});status.textContent='Nu am putut confirma adăugarea: '+(error.name==='AbortError'?'conexiunea a durat prea mult.':error.message)+' Verifică în coș înainte să încerci din nou.';}
        finally{clearTimeout(timeout);busy=false;add.disabled=success;select.disabled=success;qty.disabled=success;close.disabled=false;if(success){add.textContent='Adăugat în coș ✓';quiet(60000);}}
      });
    } else {
      node('p',complex?'Acest produs are opțiuni speciale. Completează-le în pagina produsului înainte de adăugare.':'Deschide un produs, apoi apasă „Comandă” pentru a alege rapid varianta și cantitatea.',body);
      if(complex){var go=node('button','Alege opțiunile produsului',body);go.type='button';go.addEventListener('click',function(){dialog.close();if(!mainForm){if(p && p.handle)location.href=rootPath+'products/'+encodeURIComponent(p.handle);return;}mainForm.scrollIntoView({behavior:'smooth',block:'center'});var f=mainForm.querySelector('select,input:not([type=hidden]),button');if(f)f.focus();});}
      else link('Descoperă produsele','collections/all',body);
    }
    var actions=node('div',null,body);actions.className='cqo-links';link('Vezi coșul','cart',actions);
    var ask=node('button','Întreabă asistentul',actions);ask.type='button';ask.addEventListener('click',function(){dialog.close();open();});
    if(typeof dialog.showModal==='function')dialog.showModal();else{dialog.remove();location.href=rootPath+'cart';}
  }
  window.CoriaAssistantBridge={restore:restore,open:open,ask:ask,order:order,quiet:quiet,canPrompt:canPrompt,claimPrompt:claimPrompt};
  function boot(){
    restore();
    // Recovery runs independently of WebGL and external resources.
    setTimeout(restore,4000);setTimeout(restore,12000);
    document.addEventListener('coria:ready',restore);
    document.addEventListener('coria:chat-closed',restore);
    var fab=document.getElementById('coria-fab');
    /* pastila "Comanda rapid" scoasa la cererea clientului; comanda se face din cos si din holograma mascotei */
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
